import { InitializerExecutor } from '@wajeez-web/core/types';
import { TokenService } from '@wajeez-web/stores/auth';

export const initializeAuth: InitializerExecutor = async (dispatch) => {
  await TokenService.getAccessTokenForUsageService();
};
